import type { Locale } from '@skytech/types'

import { getBrowserLocale } from './locale'

// Shows price accuracy only for GBP, USD, EUR
export const getFormattedNumberWithCurrency = ({
  currency,
  locale,
  amount,
  precision = currency === 'GBP' || currency === 'USD' || currency === 'EUR' ? 2 : 0,
}: {
  currency: Intl.NumberFormatOptions['currency']
  amount: number
  locale?: Locale
  precision?: number
}) => {
  const browserLocale = getBrowserLocale()
  const parsedLocale = locale || browserLocale

  if (typeof amount !== 'number') throw new Error('The formatted amount is not a number!')

  const config: Intl.NumberFormatOptions = {
    maximumFractionDigits: precision,
  }

  if (currency) {
    config.style = 'currency'
    config.currency = currency
  }

  return amount.toLocaleString(parsedLocale, config)
}
